/**
 * File: todayFiguresUtils.ts
 * Path: apps/admin/src/features/today/utils/todayFiguresUtils.ts
 * Description: The small chip under each of the four Today figures (overdue, care plans, win rate, hours vs last week).
 */

import { hoursText, type Tone, type TodayFigures } from "@/features/today/utils/todayOverviewUtils";

export interface FigureChip {
  tone: Tone;
  text: string;
}

const arrow = (n: number) => (n >= 0 ? "▲" : "▼");

/** `debtors` is the books' figure (late = invoices past due); without it the contracts' late payments count. */
export const figureChips = (
  f: TodayFigures,
  debtors: { lateCount: number } | null = null,
): { owed: FigureChip; mrr: FigureChip; pipeline: FigureChip; hours: FigureChip } => {
  const weekChange = f.weekMinutes - f.lastWeekMinutes;
  const late = debtors ? debtors.lateCount : f.lateCount;
  return {
    owed: late > 0 ? { tone: "red", text: `${late} overdue` } : { tone: "green", text: "None overdue" },
    mrr: {
      tone: "neutral",
      text: f.carePlanCount === 0 ? "No care plans yet" : `${f.carePlanCount} care plan${f.carePlanCount === 1 ? "" : "s"}`,
    },
    pipeline:
      f.winRatePercent === null
        ? { tone: "neutral", text: `${f.openCount} open deal${f.openCount === 1 ? "" : "s"}` }
        : { tone: "neutral", text: `${f.winRatePercent}% of quotes win` },
    hours:
      f.weekMinutes === 0 && f.lastWeekMinutes === 0
        ? { tone: "neutral", text: "No time logged yet" }
        : { tone: "neutral", text: `${arrow(weekChange)} ${hoursText(Math.abs(weekChange))} on last week` },
  };
};
